import { Field, Model } from 'serialize-ts';

@Model()
export class PriceRange {
  @Field()
  min: number | null;

  @Field()
  max: number | null;
}
